import { render, staticRenderFns } from "./Pagination.global.vue?vue&type=template&id=2296df8a&scoped=true&lang=pug&"
import script from "./Pagination.global.vue?vue&type=script&lang=ts&"
export * from "./Pagination.global.vue?vue&type=script&lang=ts&"
import style0 from "./Pagination.global.vue?vue&type=style&index=0&id=2296df8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296df8a",
  null
  
)

export default component.exports